<template>
  <div
    :class="[
      'cellBox',
      this.isStriked?'striked':'',
      this.shakeEffect?'shaking':'',
      this.dummyStrike?'dummyStrike':'',
      strikedPlayerIndex ? 'strikedPlayer' + strikedPlayerIndex : ''
    ]"
    @click="play(cellData.number)"
  >
    <div :class="['number',(isMyturn && !isStriked)?'turn':'']">{{ cellData.number }}</div>
  </div>
</template>
<script>
import store from "@/store";
import Server from "@/server";

export default {
  data: () => {
    return {
      dummyStrike: false,
      shakeEffect: false
    };
  },
  methods: {
    play(number) {
      if(this.shakeEffect || this.timeLeft<=0){
        return;
      }
      if (this.isMyturn && !this.isStriked) {
        store.dispatch('playSound','strikeAudio');
        this.dummyStrike = true;
        setTimeout(() => {
          this.dummyStrike = false;
        }, 3000);
        Server.playMyTurn(number);
      }
    },
    removePlayer(playerId){
      Server.removePlayer(playerId);
    }
  },
  computed: {
    className: function() {
      const strikedCells = store.getters.allStrikedCells;
      return ["cellBox", this.isStriked ? "striked" : ""];
    },
    isStriked: function() {
      return (
        store.getters.allStrikedCells.indexOf(this.cellData.number) >= 0 ||
        this.striked
      );
    },
    isMyturn: () => store.getters.isMyturn,
    timeLeft: () => store.getters.timeLeft,
    gameStarted: () => store.state.room.gameStarted,
    isIamNewPlayer: () => store.getters.isIamNewPlayer,
    strikedPlayerIndex: function() {
      var players = store.state.room.myRoom;
      var playerIndex = 1;
      for (var playerId in players) {
        if (players[playerId].strikedCells.indexOf(this.cellData.number) >= 0)
          return playerIndex;
        playerIndex++;
      }
      return 0;
    }
  },
  props: ["cellData"],
  watch: {
    gameStarted(newvalue, oldvalue) {
      if (newvalue != oldvalue) {
        this.dummyStrike = false;
        if(newvalue){
          this.shakeEffect = true;
          setTimeout(() => {
            this.shakeEffect = false;
          }, 1000);
        }
      }
    },
    isStriked(newvalue,oldvalue){
      if(newvalue){
        if(!this.dummyStrike){          
          store.dispatch('playSound','strikeAudio2');
        }
        this.dummyStrike = false;
      }
    }
  }
};
</script>
